import React from 'react';

import ProfileRecentWorkClient from './ProfileRecentWorkClient';
import { type WithQueryProps } from './types';

const WorkedOnListContainer = (props: WithQueryProps) => {
	return <ProfileRecentWorkClient {...props} />;
};

export default WorkedOnListContainer;
